export const COLOR_TRANSPARENT = 'transparent';
export const COLOR_BLACK = '#000000';
export const COLOR_WHITE = '#FFFFFF';
export const COLOR_GRAY_50 = '#F9F9F9';
export const COLOR_GRAY_100 = '#F0F0F0';
export const COLOR_GRAY_200 = '#E1E1E1';
export const COLOR_GRAY_300 = '#CECECE';
export const COLOR_GRAY_400 = '#BABABA';
export const COLOR_GRAY_500 = '#9C9C9C';
export const COLOR_GRAY_600 = '#8D8D8D';
export const COLOR_GRAY_700 = '#7E7E7E';
export const COLOR_GRAY_800 = '#6D6D6D';
export const COLOR_GRAY_900 = '#565656';
export const COLOR_GRAY_1000 = '#404040';
export const COLOR_GRAY_1100 = '#2B2B2B';
export const COLOR_GRAY_1200 = '#1A1A1A';
export const COLOR_GRAY_1300 = '#0A0A0A';
export const COLOR_SAND_50 = '#FAF9F8';
export const COLOR_SAND_100 = '#F3EFED';
export const COLOR_SAND_200 = '#E6DFDA';
export const COLOR_SAND_300 = '#D8CDC6';
export const COLOR_SAND_400 = '#C6B7AC';
export const COLOR_SAND_500 = '#AC9686';
export const COLOR_SAND_600 = '#A28977';
export const COLOR_SAND_700 = '#947965';
export const COLOR_SAND_800 = '#816958';
export const COLOR_SAND_900 = '#645245';
export const COLOR_SAND_1000 = '#4B3D33';
export const COLOR_SAND_1100 = '#332923';
export const COLOR_SAND_1200 = '#1F1915';
export const COLOR_SAND_1300 = '#0B0908';
export const COLOR_PURPLE_50 = '#F9F9FC';
export const COLOR_PURPLE_100 = '#F0EFF6';
export const COLOR_PURPLE_200 = '#E1E0EE';
export const COLOR_PURPLE_300 = '#CDCCE4';
export const COLOR_PURPLE_400 = '#B9B7D8';
export const COLOR_PURPLE_500 = '#9B98C8';
export const COLOR_PURPLE_600 = '#8C88BF';
export const COLOR_PURPLE_700 = '#7B77B6';
export const COLOR_PURPLE_800 = '#6A65AC';
export const COLOR_PURPLE_900 = '#524E91';
export const COLOR_PURPLE_1000 = '#3D3A6C';
export const COLOR_PURPLE_1100 = '#292749';
export const COLOR_PURPLE_1200 = '#19182C';
export const COLOR_PURPLE_1300 = '#0A0911';
export const COLOR_GREEN_50 = '#F8FBF8';
export const COLOR_GREEN_100 = '#E9F2E7';
export const COLOR_GREEN_200 = '#D4E6D1';
export const COLOR_GREEN_300 = '#BAD7B6';
export const COLOR_GREEN_400 = '#9BC595';
export const COLOR_GREEN_500 = '#6DAB65';
export const COLOR_GREEN_600 = '#5D9C55';
export const COLOR_GREEN_700 = '#538B4C';
export const COLOR_GREEN_800 = '#487942';
export const COLOR_GREEN_900 = '#395F34';
export const COLOR_GREEN_1000 = '#2B4727';
export const COLOR_GREEN_1100 = '#1D301A';
export const COLOR_GREEN_1200 = '#111D10';
export const COLOR_GREEN_1300 = '#070B06';
export const COLOR_BLUE_50 = '#F8FAFC';
export const COLOR_BLUE_100 = '#EAF1F8';
export const COLOR_BLUE_200 = '#D5E2F0';
export const COLOR_BLUE_300 = '#BBD0E7';
export const COLOR_BLUE_400 = '#9FBDDD';
export const COLOR_BLUE_500 = '#75A0CE';
export const COLOR_BLUE_600 = '#5F91C6';
export const COLOR_BLUE_700 = '#4881BE';
export const COLOR_BLUE_800 = '#3C70A8';
export const COLOR_BLUE_900 = '#2E5783';
export const COLOR_BLUE_1000 = '#234263';
export const COLOR_BLUE_1100 = '#182D43';
export const COLOR_BLUE_1200 = '#0E1B28';
export const COLOR_BLUE_1300 = '#050A0F';
export const COLOR_DARK_ORANGE_50 = '#FEF8F6';
export const COLOR_DARK_ORANGE_100 = '#FDEDE9';
export const COLOR_DARK_ORANGE_200 = '#FBDAD1';
export const COLOR_DARK_ORANGE_300 = '#F8C2B3';
export const COLOR_DARK_ORANGE_400 = '#F5A791';
export const COLOR_DARK_ORANGE_500 = '#F07B5B';
export const COLOR_DARK_ORANGE_600 = '#ED613A';
export const COLOR_DARK_ORANGE_700 = '#E64415';
export const COLOR_DARK_ORANGE_800 = '#C83A12';
export const COLOR_DARK_ORANGE_900 = '#9E2D0E';
export const COLOR_DARK_ORANGE_1000 = '#77220B';
export const COLOR_DARK_ORANGE_1100 = '#521807';
export const COLOR_DARK_ORANGE_1200 = '#330F05';
export const COLOR_DARK_ORANGE_1300 = '#150602';
export const COLOR_MEDIUM_ORANGE_50 = '#FEF8F4';
export const COLOR_MEDIUM_ORANGE_100 = '#FDEDE2';
export const COLOR_MEDIUM_ORANGE_200 = '#FCDAC4';
export const COLOR_MEDIUM_ORANGE_300 = '#FAC39F';
export const COLOR_MEDIUM_ORANGE_400 = '#F7A873';
export const COLOR_MEDIUM_ORANGE_500 = '#F37B2B';
export const COLOR_MEDIUM_ORANGE_600 = '#EA650D';
export const COLOR_MEDIUM_ORANGE_700 = '#D15B0C';
export const COLOR_MEDIUM_ORANGE_800 = '#B54E0A';
export const COLOR_MEDIUM_ORANGE_900 = '#8E3E08';
export const COLOR_MEDIUM_ORANGE_1000 = '#6B2E06';
export const COLOR_MEDIUM_ORANGE_1100 = '#492004';
export const COLOR_MEDIUM_ORANGE_1200 = '#2D1302';
export const COLOR_MEDIUM_ORANGE_1300 = '#120801';
export const COLOR_LIGHT_ORANGE_50 = '#FFF9F2';
export const COLOR_LIGHT_ORANGE_100 = '#FFEDD9';
export const COLOR_LIGHT_ORANGE_200 = '#FFDBB2';
export const COLOR_LIGHT_ORANGE_300 = '#FFC37E';
export const COLOR_LIGHT_ORANGE_400 = '#FFA742';
export const COLOR_LIGHT_ORANGE_500 = '#EE7F00';
export const COLOR_LIGHT_ORANGE_600 = '#D87300';
export const COLOR_LIGHT_ORANGE_700 = '#C16700';
export const COLOR_LIGHT_ORANGE_800 = '#A75900';
export const COLOR_LIGHT_ORANGE_900 = '#834600';
export const COLOR_LIGHT_ORANGE_1000 = '#623400';
export const COLOR_LIGHT_ORANGE_1100 = '#432400';
export const COLOR_LIGHT_ORANGE_1200 = '#291600';
export const COLOR_LIGHT_ORANGE_1300 = '#0F0800';
export const COLOR_BRAND_WHITE = COLOR_WHITE;
export const COLOR_BRAND_LIGHT_ORANGE = COLOR_LIGHT_ORANGE_500;
export const COLOR_BRAND_MEDIUM_ORANGE = COLOR_MEDIUM_ORANGE_600;
export const COLOR_BRAND_DARK_ORANGE = COLOR_DARK_ORANGE_700;
